<template>
  <article class="col-xs-12 col-md-8 mb-40">
    <h2 class="mb-30">SECTORS</h2>
    <div class="row ">
      <div class="col-xs-12 col-md-4">
        <p>The funder is active in the following sectors:</p>
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="chart row expanded">
          <div id='chart' class="col-md-8 mb-4 chart-graphs"></div>
          <!-- col-xs-7 col-xsm-8 -->
          <!-- col-xs-5 col-xsm-4  -->
          <div class="col-md-4 color-list align-self-center">
            <ul>
              <li v-for="sector in sectorData">
                <span
                  class="indication"
                  :class="sector.class">
                </span> {{ sector.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "SectorChart",
  props: ["provider"],
  watch: {
    provider: {
      handler: function() {
        this.refreshChart();
      },
      deep: true
    }
  },
  mounted() {
    this.drawChart(this.provider);
  },
  computed: {
    sectorData: function() {
      var colors = ['#2e3539', '#30495b', "#28566f", "#1b769e", "#149ece"];
      var data = [];
      var j = 0;
      this.provider.provider_sectors.forEach((sector, i) => {
        if (sector.sector != null) {
          if (j < 5) {
            data.push({
              name: sector.sector.name,
              value: sector.relevancy,
              class: `indication-${j+1}`,
              color: colors[j]
            });
            j = j + 1;
          }
        }
      });
      return data;
    }
  },
  methods: {
    refreshChart: function() {
      this.clearCanvas();
      this.drawChart(this.provider);
    },
    clearCanvas: function() {
      d3.select("#chart")
        .selectAll("*")
        .remove();
    },
    drawChart: function(provider) {
      if (provider == undefined) return;
      var data = this.sectorData;
      var padding = 0;

      var opacity = 0.8;
      var percentFormat = d3.format(",.2%");

      var chart = d3.select("#chart");

      var boundingRect = chart.node().getBoundingClientRect();
      var width = boundingRect.width;
      var height = 220;
      var radius = Math.min(width - padding, height - padding) / 2;

      var svg = chart
        .append("svg")
        .attr("class", "pie")
        .attr("width", width)
        .attr("height", height);

      var g = svg
        .append("g")
        .attr("transform", "translate(" + ((width / 2 ) -20 )+ "," + height / 2 + ")");

      var arc = d3
        .arc()
        .outerRadius(radius)
        .innerRadius(radius * 0.45);

      var pie = d3
        .pie()
        .value(function(d) {
          return d.value;
        })
        .sort(null);

      function toolTipHTML(data) {
        var tip = "",
          i = 0;
        for (var key in data.data) {
          if (key == "color") continue;
          var value = !isNaN(parseFloat(data.data[key]))
            ? percentFormat(data.data[key])
            : data.data[key];

          if (key == "name" && value.includes("&")) {
            var index = value.indexOf("&");
            var tip =
              '<tspan x="0">' +
              value.slice(0, index) +
              '</tspan><tspan x="0" dy="1.2em">' +
              value.slice(index) +
              "</tspan>";
          }
          if (i === 0)
            if (key == "name" && !value.includes("&")) {
              tip +=
                '<tspan x="0">' +
                value.replace(" ", '</tspan><tspan x="0" dy="1.2em">') +
                "</tspan>";
            }
          // else tip += '<tspan x="0" dy="1.2em">' + value + "</tspan>";
          i++;
        }
        return tip;
      }

      g.selectAll("path")
        .data(pie(data))
        .enter()
        .append("g")
        .append("path")
        .attr("d", arc)
        .attr("fill", d => {
          return d.data.color;
        })
        .style("opacity", opacity)
        .style("stroke", "white")
        .on("mouseenter", function(data) {
          svg
            .append("text")
            .attr("class", "toolCircle")
            .attr("dy", -5)
            .html(toolTipHTML(data))
            .attr(
              "transform",
              "translate(" + ((width / 2 ) - 20 ) + "," + height / 2 + ")"
            )
            .style("font-size", "1em")
            .style("text-anchor", "middle");
          svg
            .append("circle")
            .attr("class", "toolCircle")
            .attr("r", radius * 0.43)
            .attr(
              "transform",
              "translate(" + ((width / 2 ) - 20 ) + "," + height / 2 + ")"
            )
            .style("fill", data.data.color)
            .style("fill-opacity", 0.35);
        })
        .on("mouseout", function() {
          d3.selectAll(".toolCircle").remove();
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/charts/SectorChart.vue